// extracted by mini-css-extract-plugin
export default {"header":"header_header__Uy8lx","header__wing":"header_header__wing__fBv4O","header__nav":"header_header__nav__j7nx5"};